import { Skeleton, Typography, TypographyProps } from '@mui/material'
import pxToRem from '../../../../../helpers/pxToRem'

const CustomCell = ({
    loading,
    value,
    height,
    width,
    noWrap,
    props,
}: {
    loading?: boolean
    value: any
    height?: number
    width?: number
    noWrap?: boolean
    props?: { Typography?: TypographyProps }
}) => {
    if (loading) {
        return (
            <Skeleton width={width ? pxToRem(width) : 'fit-content'}>
                <Typography>.</Typography>
            </Skeleton>
        )
    }
    return (
        <Typography
            width={width ? pxToRem(width) : 'fit-content'}
            height={height ? pxToRem(height) : 'fit-content'}
            noWrap={noWrap || false}
            variant="ps"
            px={2}
            {...props?.Typography}
        >
            {value}
        </Typography>
    )
}

export const CustomCellV2 = ({
    loading,
    children,
}: {
    loading: boolean
    children: JSX.Element
}) => {
    if (loading) {
        return <Skeleton>{children}</Skeleton>
    }
    return children
}

export default CustomCell
